/****************************************************
 * Module Name:  addPacketReceiveModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import { Button, Typography, TextField, Tooltip } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import LossProxy from "../../utility/proxy/manager/manufacturingProxy/lossProxy";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Select from "react-select";
import Utility from "../../utility/utility";
import SettingsProxy from "../../utility/proxy/manager/settingsProxy";
import KapanCreationProxy from "../../utility/proxy/manager/manufacturingProxy/kapanCreationProxy";
import CommonSnackbar from "../common/commonSnackBar";

const AddPacketReceiveModal = ({
    show,
    setShow,
    handleValidation,
    handleSave,
    sourceData,
    loading
}) => {
    const [showErrorMessage, setShowErrorMessage] = useState("");
    const [newCarat, setNewCarat] = useState(sourceData.carats);
    const [remark, setRemark] = useState("");
    const [lossRemark, setLossRemark] = useState("");
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [categoryLoadSpinner, setCategoryLoadSpinner] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarVariant, setSnackbarVariant] = useState("");

    useEffect(() => {
        getAllcategory(false);
    }, []);

    useEffect(() => {
        if (newCarat && sourceData.carats !== newCarat) {
            getDefaultLossRemartCategory((updatedCategory) => {
                categoryOptions.forEach(iOption => {
                    if (iOption.value === updatedCategory) {
                        setLossRemark(iOption);
                    }
                });
            });
        }
    }, [newCarat]);

    const getDefaultLossRemartCategory = (callback) => {
        const settingKey = "MFG_DEPARTMENT_RECEIVE_DEFAULT_LOSS_CATEGORY_ID";
        SettingsProxy.GetSettingByName(settingKey, response => {
            if (response && response.settingvalue && response.settingvalue !== "") {
                if (callback) {
                    callback(parseInt(response.settingvalue));
                }
            }
        });
    }

    const getAllcategory = (bAnimateSpinner) => {
        bAnimateSpinner && setCategoryLoadSpinner(true);
        LossProxy.GetAllLossMini((response) =>
            setAllCategoryData(response)
        );
    };

    const setAllCategoryData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = {
                value: data.id,
                label: data.category,
            };
            optionsArray.push(option);

            return true;
        });
        setCategoryOptions(optionsArray);
        setCategoryLoadSpinner(false);
    };

    const prepareData = () => {
        return [{
            kapanid: parseInt(sourceData.kapanid),
            packetid: sourceData.packetid,
        }];
    };


    const saveHandler = () => {
        let receieveData = {
            userid: Constants.loggedInUser.id,
            kapanpackets: prepareData()
        };

        if (sourceData.carats !== newCarat) {
            let data = {
                kapanid: sourceData.kapanid,
                packetid: sourceData.packetid,
                oldcarat: sourceData.carats,
                newcarat: parseFloat(newCarat),
                oldprice: sourceData.price,
                newprice: sourceData.price,
                remark: remark,
                responsibleuserid: sourceData.userid,
                reportedbyuser: Constants.loggedInUser.id,
                losscategoryid: lossRemark.value,
                reportedbydepartment: sourceData.next_department_id
            };

            KapanCreationProxy.AddPacketLossRemarkCategory(data, (response) => {
                if (response) {
                    receive(receieveData);
                } else {
                    setSnackbarState(true, Constants.APiFailErrorMessage, "error");
                }
            });
        } else {
            receive(receieveData);
        }
    };

    const receive = (receieveData) => {
        if (handleSave) {
            if (handleValidation) {
                if (handleValidation(receieveData)) {
                    //need to add locationId here and in the parent component if need for validation
                    handleSave(receieveData);
                } else {
                    setSnackbarState(true, Constants.APiFailErrorMessage, "error");
                }
            } else {
                handleSave(receieveData);
            }
        }
    }

    const setSnackbarState = (show, message, variant) => {
        setShowSnackbar(show);
        setSnackbarMessage(message);
        setSnackbarVariant(variant);
    };

    const handleDisable = () => {
        return !(newCarat && showErrorMessage.length === 0);
    };

    return (
        <div>
            <CommonSnackbar
                show={showSnackbar}
                message={snackbarMessage}
                variant={snackbarVariant}
                autoHide={false}
                handleClose={() => setShowSnackbar(false)}
                title={snackbarVariant}
            />
            <Modal
                show={show}
                onHide={setShow}
                enforceFocus={false}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp; Packet Receive
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <center>
                        <table style={{ width: "100%" }}>
                            <tbody>
                                <tr>
                                    <td>
                                        <Form.Label>Carat</Form.Label>
                                    </td>
                                    <td>
                                        <Typography style={{ marginLeft: '5px' }}>{sourceData.carats}</Typography>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>New Carat<sup style={{ color: "red" }}>*</sup></Form.Label>
                                    </td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            type="number"
                                            label="Enter New Carat"
                                            placeholder="Enter New Carat"
                                            value={newCarat}
                                            onChange={(e) => {
                                                setNewCarat(e.target.value);
                                                setShowErrorMessage(Utility.CheckIsPresent(e.target.value) ? Utility.CheckisNumberNegative(e.target.value) ? 'Carat cannot be negative' : "" : 'Carat cannot be Empty');
                                            }
                                            }
                                            helperText={showErrorMessage}
                                            error={showErrorMessage.length > 0}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>Loss Category <sup style={{ color: "red" }}>*</sup></Form.Label>
                                    </td>
                                    <td>
                                        <Select menuPlacement="auto"
                                            blurInputOnSelect={false}
                                            getOptionLabel={(option) => option.label}
                                            getOptionValue={(option) => option.value}
                                            value={lossRemark}
                                            isSearchable={true}
                                            closeMenuOnSelect={true}
                                            name="Loss Category"
                                            menuPortalTarget={document.body}
                                            styles={Constants.Styles}
                                            options={categoryOptions}
                                            isDisabled={newCarat ? sourceData.carats === newCarat : true}
                                            onChange={(selectedOption) =>
                                                setLossRemark(selectedOption)
                                            }
                                        />
                                    </td>
                                    <td>
                                        {categoryLoadSpinner ? (
                                            <CircularProgress
                                                size="1em"
                                                sx={{ mt: 1.5, ml: 0.7 }}
                                            />
                                        ) : (
                                            <Tooltip title="Reload">
                                                <RefreshOutlinedIcon
                                                    color="primary"
                                                    fontSize="medium"
                                                    onClick={() => getAllcategory(true)}
                                                    sx={{
                                                        cursor: "pointer",
                                                        mt: 1,
                                                    }}
                                                />
                                            </Tooltip>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>Remark</Form.Label>
                                    </td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            multiline
                                            label="Remark"
                                            placeholder="Enter Remark"
                                            value={remark}
                                            disabled={newCarat ? sourceData.carats === newCarat : true}
                                            onChange={(e) =>
                                                setRemark(e.target.value)
                                            }
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                            </tbody>
                        </table>
                    </center>
                </Modal.Body>
                <Modal.Footer>
                    <LoadingButton
                        loading={loading}
                        variant="contained"
                        onClick={saveHandler}
                        disabled={handleDisable()}
                        type="Submit"
                        sx={{ mr: 3 }}
                    >
                        Receive
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={setShow}
                        sx={{ mr: 2 }}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AddPacketReceiveModal;
